import React from 'react';
import { Table } from '../../../base/Table';
import styles from './index.module.scss';
import { RetryIcon } from '../../../../../../resource/icons';

const RepeatCell = ({ record, column, row }) => {
  return (
    <Table.BodyCellWithDefault
      renderCondition={Boolean(record.isRepeat)}
      column={column}
      row={row}
      type="default"
    >
      <RetryIcon className={styles.icon} />
    </Table.BodyCellWithDefault>
  );
};

export default RepeatCell;
